export const leaseInformationTemplate = [
	{
		id: 'e92d5fe2-df03-430f-9a58-5017157e8e3a',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Purpose',
				styles: {
					bold: true,
				},
			},
		],
		children: [],
	},
	{
		id: 'd90c9e68-8a9d-468e-9626-6ff6a61a88ed',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Provide a centralized record of key lease terms, landlord contacts, rent obligations, and critical dates to support easy reference, compliance, and timely renewals.',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '35924c32-af2d-469c-a2a8-5c442d997339',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: '1. Lease Details',
				styles: {
					bold: true,
				},
			},
		],
		children: [],
	},
	{
		id: '4c7c81c4-4f7e-4bd9-8ccd-3be527f251e7',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Lease Start Date: [MM/DD/YYYY]',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '5f5d61ab-1afd-4478-9bc1-bf2cad81b5ce',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Lease End Date: [MM/DD/YYYY]',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'a13131a5-70d0-4ec4-9dec-10ec34e853c9',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Renewal Terms: [Auto-renewal, Negotiated terms, etc.]',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '308c2186-4e71-45c1-b9d8-32ef360f4762',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Rent Schedule: [Monthly/Quarterly/Annually + Amount]',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'aa37759f-34a1-433f-bbf6-45120edaf77d',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Security Deposit: [Amount, if applicable]',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'c1a18031-5568-4308-acb8-69f6d70bd7ff',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: '\n',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '636fef1d-732e-471b-9c88-20aa244d1766',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: '2. Parties Involved',
				styles: {
					bold: true,
				},
			},
		],
		children: [],
	},
	{
		id: '44a39ff9-a071-40e6-955a-0e55d5b27d91',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Landlord Name: [Full Name / Company]',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '83b36eca-117b-4a0c-9137-201f4c67ea3a',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Landlord Contact: [Phone, Email]',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'a514a993-e209-4740-983a-a608c1f681e7',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Tenant / Entity: [Company / Organization Name]',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '07f74faf-da4f-425a-b08a-f747d4d40553',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: '\n',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '2b2c7a4c-d7da-4f57-8aa8-722776d8c789',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: '3. Insurance and Compliance',
				styles: {
					bold: true,
				},
			},
		],
		children: [],
	},
	{
		id: 'ccb2067b-23c8-408b-98ed-96c9b54c0a22',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Insurance Clauses: [General liability, property insurance, additional insured, etc.]',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'b31ca6be-0ad6-4ef5-8680-39eb8d91706b',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Compliance Notes: [Any obligations under lease: fire code, maintenance, etc.]',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'fc684990-d007-4226-8708-105f296f6319',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: '\n',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'a5ac3cf8-509e-49b8-8216-b888aa7af71d',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: '4. Key Dates Tracker',
				styles: {
					bold: true,
				},
			},
		],
		children: [],
	},
	{
		id: '2e02e08e-f834-4ef0-b6b4-69eb5b26eb2c',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Rent Due Date(s): [e.g., 1st of every month]',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'a9cccf50-b2fc-4ca1-8fc1-0e16bff241c9',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Renewal Notice Deadline: [MM/DD/YYYY]',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'eca6faa6-31ae-49ee-bf3d-ca5f81adfe7a',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Escalation Increase Date(s): [MM/DD/YYYY]',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '5a4fbff4-16e8-461e-bc5e-e491d7d55997',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Termination Notice Period: [# of days/months required]',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '50dcee91-8cde-4793-8c20-5eb2518ecad5',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: '5. Attachments & References',
				styles: {
					bold: true,
				},
			},
		],
		children: [],
	},
	{
		id: 'c104baf8-7e33-42fe-820d-fcecd9a67764',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Lease Agreement Document: [Upload]',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '5b72c148-269f-4b2e-9771-300384a2f4d8',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Addendums / Riders: [Upload if applicable]',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'dacf59c7-5c65-47bc-bf3f-230c0ab71449',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: 'Renewal Notice / Amendments: [Upload]',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: '398d0461-941a-44b6-a289-d84c2b8d6ff9',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: '6. Notes / Additional Information',
				styles: {
					bold: true,
				},
			},
		],
		children: [],
	},
	{
		id: '0112ea90-ec1a-40e2-964c-a6e52b6668a3',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: '\n',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'f4f6fd3f-1650-4f1a-81ef-ab40d886fd8d',
		type: 'bulletListItem',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [
			{
				type: 'text',
				text: '[Any additional comments, special terms, landlord preferences, or site-specific details]',
				styles: {},
			},
		],
		children: [],
	},
	{
		id: 'd066c150-b6ae-4fba-8297-8d114f3fb062',
		type: 'paragraph',
		props: {
			textColor: 'default',
			backgroundColor: 'default',
			textAlignment: 'left',
		},
		content: [],
		children: [],
	},
];
